export default __webpack_public_path__ + "static/media/DonCarlosBG.d70471b9.jpg";